import decode from 'jwt-decode';

const checkAdminAuth = () => {
  try {
    const token = localStorage.getItem('token');
    // console.log('checkAdminAuth: Retrieved token:', token);
    if (!token) {
      console.log('checkAdminAuth: No token found');
      localStorage.clear();
      return { authed: false, role: null };
    }

    const decoded = decode(token);
    // console.log('checkAdminAuth: Decoded token:', decoded);
    const currentTime = Date.now() / 1000;

    if (decoded.exp < currentTime) {
      // console.log('checkAdminAuth: Token expired');
      localStorage.clear();
      return { authed: false, role: null };
    }

    const role = decoded.role;
    // console.log('checkAdminAuth: User role:', role);
    if (!['user', 'admin', 'superadmin'].includes(role)) {
      // console.log('checkAdminAuth: Invalid role, expected: user, admin, superadmin');
      localStorage.clear();
      return { authed: false, role: null };
    }

    return { authed: true, role };
  } catch (error) {
    // console.error('checkAdminAuth error:', error.message);
    localStorage.clear();
    return { authed: false, role: null };
  }
};

export default checkAdminAuth;